import { IRoleDetail } from 'us.common/interfaces';

export const roleDetail: IRoleDetail = {
    roleId: 0,
    name: '',
    description: '',
    activeState: true,
    actions: [],
    checkedAction: { "1": [5] }
}